import Optional from '../../../utils/optional';

const mapCarrierData = carrierData => {
  const {
    carrier_settings: { characteristic }
  } = carrierData;

  const filteredCharacteristics = characteristic.filter(
    char =>
      char.visible === true &&
      char.technical === false &&
      char.name !== 'ICCID' &&
      char.name !== 'Phone Number'
  );

  return {
    overview: {
      ICCID: Optional(characteristic.find(char => char.name === 'ICCID'))
        .map(char => char.displayValue[0])
        .or(''),
      phoneNumber: Optional(
        characteristic.find(char => char.name === 'Phone Number')
      )
        .map(char => char.displayValue[0])
        .or(''),
      productName: Optional(carrierData.carrier_settings.name).or(''),
      productStatus: Optional(carrierData.carrier_settings.status).or(''),
      productId: Optional(carrierData.carrier_settings.rootProductId).or(''),
      startDate: Optional(carrierData.carrier_settings.startDate).or(''),
      simType: Optional(characteristic.find(char => char.name === 'SIM Type'))
        .map(char => char.displayValue[0])
        .or('')
    },
    characteristics: filteredCharacteristics,
    products: carrierData.carrier_settings.product
  };
};

export default mapCarrierData;
